import { Lookup } from './lookup.model';
import { OptionSet } from './optionSet.model';
export class Panel {
    DoctoProntoPago: number;
    ReservaDias: number;
    SimulacionDias: number;
    ValorMoraCFTST: number;
    ValorMoraIPST: number;
    ValorMoraUST: number;
    AnhoAcademico: number;
    AnhoIngreso: number;
    SemestreAcademico: number;
    TipoPrograma: string;
    ViaAdmision: string;
    PeriodoAdm: Lookup;
    Origen: Lookup;
    SubOrigen: Lookup;
    //  No tocar
    Institucion:Lookup;
    Sede:Lookup;
    Carrera:Lookup;
    Jornada:OptionSet;
    TipoIngreso:Lookup;

}